export const AUTH_ENDPOINT = process.env.REACT_APP_AUTH_ENDPOINT || 'http://localhost:3000';
export const SURVEY_ENDPOINT = process.env.REACT_APP_SURVEY_ENDPOINT || 'http://localhost:3000';